import React from "react";
import withIconComponent from "../withIconComponent";

var SmallRight = function SmallRight() {
  return /*#__PURE__*/React.createElement("path", {
    d: "M10 8l4 4-4 4",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  });
};

export default withIconComponent("UiSmallRight", false)(SmallRight);